// @flow
import type { Node } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import toLower from 'ramda/es/toLower'

import { maskType } from './mask-types'

// Зависимость маски поля ввода телефона от дилера
// DEPRECATED: нужно убирать redux,
// поэтому переносим локально в каждый кабинет
// в app/components/useDealerPhoneMask.ts
// пример в зеленом кабинете

const maskTypeByIsoCode: {
  [string]: $Values<typeof maskType>,
} = {
  ru: maskType.MASK_PHONE_RU,
  kg: maskType.MASK_PHONE_KG,
  kz: maskType.MASK_PHONE_KZ,
  ua: maskType.MASK_PHONE_UA,
}

type Props = {
  children: (predefinedMaskType: $Values<typeof maskType>) => Node,
}

const DealerPhoneMask = ({ children }: Props): Node => {
  const { country_iso_code: isoCode = 'ru' } = useSelector((state) => state.dealer, shallowEqual)
  const iso = toLower(isoCode)
  const maskType: $Values<typeof maskType> = maskTypeByIsoCode[iso] || maskType.MASK_PHONE_RU

  return children(maskType)
}

export default DealerPhoneMask
